import BaseModel from './BaseModel';

class BatteryModel extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.istelematicsavailble = data.istelematicsavailble || false;
    this.description = data.description || "";
    this.weight = data.weight || "";
    this.length = data.length || "";
    this.width = data.width || "";
    this.height = data.height || "";
    this.capacity_ah = data.capacity_ah || "";
    this.capacity_volt = data.capacity_volt || "";
    this.committed_swap_cycles = data.committed_swap_cycles || "";
    this.battery_type_id = data.battery_type_id || "";
    this.ean_code = data.ean_code || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      battery_model: {
        name: this.name,
        description: this.description,
        istelematicsavailble: this.istelematicsavailble,
        weight: this.weight,
        length: this.length,
        width: this.width,
        height: this.height,
        capacity_ah: this.capacity_ah,
        capacity_volt: this.capacity_volt,
        committed_swap_cycles: this.committed_swap_cycles,
        battery_type_id: this.battery_type_id,
        ean_code: this.ean_code,
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field] === "") {
          this.errors.name = "Battery model name cannot be blank";
        } else{
          delete this.errors.name;
        }
      },
      ean_code: () => {
        if(this[field] === "") {
          this.errors.ean_code = "Battery model EAN code cannot be blank";
        } else{
          delete this.errors.ean_code;
        }
      },
      weight: () => {
        if(this[field] === ""){
          this.errors.weight = "This field is required";
        } else{
          delete this.errors.weight;
        }
      },
      length: () => {
        if(this[field] === ""){
          this.errors.length = "This field is required."
        } else{
          delete this.errors.length;
        }
      },
      width: () => {
        if(this[field] === ""){
          this.errors.width = "This field is required."
        } else{
          delete this.errors.width;
        }
      },
      height: () => {
        if(this[field] === ""){
          this.errors.height = "This field is required."
        } else{
          delete this.errors.height;
        }
      },
      capacity_ah: () => {
        if(this[field] === ""){
          this.errors.capacity_ah = "This field is required."
        } else{
          delete this.errors.capacity_ah;
        }
      },
      capacity_volt: () => {
        if(this[field] === ""){
          this.errors.capacity_volt = "This field is required."
        } else{
          delete this.errors.capacity_volt;
        }
      },
      committed_swap_cycles: () => {
        if(this[field] === ""){
          this.errors.committed_swap_cycles = "This field is required."
        } else{
          delete this.errors.committed_swap_cycles;
        }
      },
      battery_type_id: () => {
        if(this[field] === ""){
          this.errors.battery_type_id = "This field is required."
        } else{
          delete this.errors.battery_type_id;
        }
      },
      description: () => {
        if(this[field] === ""){
          this.errors.description = "This field is required."
        } else{
          delete this.errors.description;
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default BatteryModel;
